'use strict';

import type { UserActionSuggestion } from '../../Entities/User/UserActionSuggestion';
import { EntityCollection } from '../EntityCollection';

export class UserActionSuggestionCollection extends EntityCollection<UserActionSuggestion> {}
